import * as React from 'react';
import { colors } from '../../../index';

const IconCircleEight = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 21 22",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .046)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    opacity: 0.147,
    fill: "#FCFCFC",
    cx: 10.5,
    cy: 10.5,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.351 8.951c0 .355-.093.67-.28.946-.187.277-.44.493-.759.65.37.159.664.391.88.697.217.305.325.652.325 1.039 0 .614-.207 1.104-.622 1.468-.415.364-.96.546-1.637.546-.682 0-1.23-.183-1.64-.548-.412-.366-.618-.855-.618-1.466 0-.384.105-.73.315-1.04.21-.308.5-.542.87-.702a1.861 1.861 0 01-.746-.648 1.673 1.673 0 01-.273-.942c0-.598.192-1.073.575-1.424.384-.351.89-.527 1.517-.527.625 0 1.13.176 1.515.527.385.351.578.826.578 1.424zm-.736 3.312c0-.396-.126-.72-.378-.97-.253-.25-.582-.376-.988-.376-.407 0-.733.124-.978.37-.246.248-.369.573-.369.976 0 .404.12.72.359.951.239.231.571.347.997.347.423 0 .755-.116.996-.349.24-.232.36-.549.36-.949zm-1.357-4.522c-.354 0-.641.11-.86.33-.22.22-.33.518-.33.895 0 .36.108.653.325.875.216.223.505.335.865.335.361 0 .65-.112.866-.335.217-.222.325-.514.325-.875s-.112-.655-.337-.883a1.148 1.148 0 00-.854-.342z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

export default IconCircleEight;